import { type FC } from 'react';
import { Link } from 'react-router';
import { Button, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { type PayoutTraderStatus } from '~/entities/payout';
import { TraderStatusBadge } from '../TraderStatusBadge';

interface TraderEditorHeaderProps {
    backUrl: string;
    traderDisplayName: string;
    status?: PayoutTraderStatus;
}

export const TraderEditorHeader: FC<TraderEditorHeaderProps> = ({ backUrl, traderDisplayName, status }) => {
    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Group
                justify='space-between'
                align='flex-start'
                gap='md'
            >
                <Stack gap={4}>
                    <Button
                        component={Link}
                        to={backUrl}
                        variant='subtle'
                        size='xs'
                        w='fit-content'
                        leftSection={<IconArrowLeft size={16} />}
                    >
                        К списку трейдеров
                    </Button>

                    <Group
                        gap='xs'
                        align='center'
                    >
                        <Title
                            order={2}
                            size='h3'
                        >
                            Трейдер выплат
                        </Title>

                        <TraderStatusBadge status={status} />
                    </Group>

                    <Text
                        size='sm'
                        c='dimmed'
                    >
                        {traderDisplayName}
                    </Text>
                </Stack>
            </Group>
        </Paper>
    );
};
